<template>
  <section class="py-12">
    <div class="container-wrap desktop:h-[500px]">
      <div class="desktop:flex desktop:h-full desktop:items-center">
        <div class="desktop:w-1/2">
          <h2 class="mb-6 text-2xl font-bold desktop:text-3xl">
            {{ contextData.sectionTitle }}
          </h2>
          <AreaHomePartnershipButtonArea
            v-if="!isMobile"
            :partnership="contextData"
          />
        </div>
        <AreaHomePartnershipLogoArea :partnership="contextData" />
        <AreaHomePartnershipButtonArea
          v-if="isMobile"
          :partnership="contextData"
        />
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
  import EN_AMERICAS_JSON from '@/assets/data/home/en-americas/section-5.json';
  import EN_ASIA_PACIFIC_JSON from '@/assets/data/home/en-asia-pacific/section-5.json';
  import EN_EMEA_JSON from '@/assets/data/home/en-emea/section-5.json';
  import EN_INT_JSON from '@/assets/data/home/en-int/section-5.json';
  import EN_JP_JSON from '@/assets/data/home/en-jp/section-5.json';
  import EN_KR_JSON from '@/assets/data/home/en-kr/section-5.json';
  import EN_TW_JSON from '@/assets/data/home/en-tw/section-5.json';
  import JA_JP_JSON from '@/assets/data/home/ja-jp/section-5.json';
  import ZH_CN_JSON from '@/assets/data/home/zh-cn/section-5.json';
  import ZH_TW_JSON from '@/assets/data/home/zh-tw/section-5.json';
  import type { IPartnership } from '@/assets/types/Home';

  const { locale } = useI18n();

  const { isMobile } = useScreen();

  const contextData = computed((): IPartnership => {
    switch (locale.value) {
      case EnumLocale.EN_INT:
        return EN_INT_JSON;
      case EnumLocale.EN_AMERICAS:
        return EN_AMERICAS_JSON;
      case EnumLocale.EN_JP:
        return EN_JP_JSON;
      case EnumLocale.EN_TW:
        return EN_TW_JSON;
      case EnumLocale.EN_KR:
        return EN_KR_JSON;
      case EnumLocale.EN_ASIA_PACIFIC:
        return EN_ASIA_PACIFIC_JSON;
      case EnumLocale.EN_EMEA:
        return EN_EMEA_JSON;
      case EnumLocale.ZH_TW:
        return ZH_TW_JSON;
      case EnumLocale.ZH_CN:
        return ZH_CN_JSON;
      case EnumLocale.JA_JP:
        return JA_JP_JSON;
      default:
        return EN_INT_JSON;
    }
  });
</script>
